<template lang="pug">
  .team-view-all
    WtTitle(h1) {{ team.name }}
    BLoading(:active="!teamMembersLoaded")
    TeamAllMembers(v-if="teamMembersLoaded" :members="teamMembers")

</template>

<script>
import { mapActions } from "vuex";
import WtTitle from "@@/WtTitle/WtTitle";
import TeamAllMembers from "@@/Teams/TeamAllMembers";

export default {
  name: "TeamViewAll",

  components: {
    TeamAllMembers,
    WtTitle
  },

  data() {
    return {
      team: {
        id: null,
        name: null,
        description: null,
        public: null,
        inviteOnly: null,
        logo: null,
        maxMembers: null,
        numMembers: null
      },
      teamLoaded: false,
      teamMembers: [],
      teamMembersLoaded: false
    };
  },

  methods: {
    ...mapActions("teams", ["teamShow", "fetchTeamMembers"])
  },

  beforeRouteEnter(to, _, next) {
    next(async vm => {
      vm.team = await vm.teamShow({ teamId: vm.$route.params.teamId });
      vm.teamLoaded = true;
      vm.fetchTeamMembers({
        teamId: vm.team.id,
        perPage: vm.team.numMembers
      }).then(response => {
        vm.teamMembers = response.data.data;
        vm.teamMembersLoaded = true;
      });
    });
  }
};
</script>

<style lang="sass"></style>
